module.exports = __webpack_public_path__ + "static/img/Bachelor_010792.8469314.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010792.jpg
// module id = 248
// module chunks = 0